import { originalManufacturerImage } from './localManufacturerImages.js';
const BASE_URL = 'https://1woodfloors.com';
export const RECLAIMED_SHARE_IMAGE = { url: `${BASE_URL}/assets/reclaimed-project-fireplace-Cn6SMg3k.webp`, width: 360, height: 480, alt: 'Reclaimed antique oak floor at a brick fireplace hearth, Lexington, MI' };
export const RECLAIMED_JOB_PHOTOS = [
  { baseName: 'award-closeup', alt: 'Reclaimed barnwood floor with a Rubio Monocoat finish, Farmington Hills, MI' },
  { baseName: 'reclaimed-project-vent', alt: 'Flush brass honeycomb register set into a reclaimed antique oak floor, Lexington, MI' },
  { baseName: 'reclaimed-project-fireplace', url: RECLAIMED_SHARE_IMAGE.url, alt: 'Reclaimed antique oak floor in random 4 to 8 inch widths with an oil finish at a brick hearth, Lexington, MI' },
  { baseName: 'reclaimed-project-closeup', alt: 'Close up of original saw marks on a reclaimed antique oak floor, Lexington, MI' },
  { baseName: 'reclaimed-ceiling-wide', alt: 'Thermally modified reclaimed Douglas fir 8 inch plank ceiling, Lexington, MI' },
  { baseName: 'reclaimed-ceiling-vaulted', alt: 'Reclaimed Douglas fir cathedral ceiling with a fabricated beam, Lexington, MI' },
  { baseName: 'reclaimed-ceiling-detail', alt: 'Detail of a thermally modified reclaimed Douglas fir ceiling, Lexington, MI' },
];
export const RECLAIMED_OLDE_PHOTOS = {
  '/reclaimed-barnwood': RECLAIMED_JOB_PHOTOS,
  '/brands/olde-wood': [RECLAIMED_JOB_PHOTOS[0], { ...RECLAIMED_JOB_PHOTOS[2], alt: RECLAIMED_SHARE_IMAGE.alt }],
};
export function makeReclaimedOldeSchemas(path, resolveImage) {
  const photos = RECLAIMED_OLDE_PHOTOS[path] || [];
  return [...photos.map(photo => {
    const url = photo.url || resolveImage(photo.baseName);
    return { '@context': 'https://schema.org', '@type': 'ImageObject', '@id': `${BASE_URL}${path}#photo-${photo.baseName}`, url, contentUrl: url, caption: photo.alt, creditText: '1 Wood Floors', creator: { '@id': `${BASE_URL}/#organization` }, copyrightHolder: { '@id': `${BASE_URL}/#organization` } };
  }), { '@context': 'https://schema.org', '@type': 'WebPage', url: `${BASE_URL}${path}`, ...(path.startsWith('/brands/') ? { about: { '@type': 'Brand', name: 'Olde Wood Limited' } } : {}), primaryImageOfPage: { '@id': `${BASE_URL}${path}#photo-reclaimed-project-fireplace` } }];
}
const sampleAlts = {};
function add(rows) {
  for (const row of rows.trim().split('\n')) { const [file, alt] = row.split('|'); sampleAlts[file] = alt; }
}
add(`
ant-thumb-wide-plank|Olde Wood Antique Reclaimed flooring
trad-thumb-wide-plank|Olde Wood Traditional Plank flooring
metro-thumbnail|Olde Wood Metro Collection flooring
magnolia-thumbnail|Olde Wood Magnolia Collection flooring
venture-thumbnail|Olde Wood Venture Collection flooring
european-thumbnail|Olde Wood European Collection flooring
select-and-prime-thumbnail-new|Olde Wood Select & Prime flooring
rift-and-quartered-thumbnail|Olde Wood Rift & Quartered flooring
thumbnail-inspiration|Olde Wood Inspiration Collection flooring
ant-thumb-oak-white|Olde Wood Reclaimed Oak, Appearance Grade White Oak reclaimed wide plank flooring
ant-oak-hitskip-owl7-nat-oil-9-490x400-cypress-hollowa-watermarked|Olde Wood Reclaimed Oak Hit Skip reclaimed wide plank flooring
thumbnailresawnappearancegradewhiteoakkitchen|Olde Wood Reclaimed Resawn Oak, Appearance Grade White Oak reclaimed wide plank flooring
thumbnailoakoriginalfacerestaurant|Olde Wood Reclaimed Oak, Original Face reclaimed wide plank flooring
thumbnailbeechmaplecafe-1|Olde Wood Reclaimed Beech and Maple reclaimed wide plank flooring
ant-heart-pine-hitskipflooringpagelistingimage-highres-copy|Olde Wood Reclaimed Heart Pine Hit Skip reclaimed wide plank flooring
ant-heartpine-select-wm-498x400|Olde Wood Reclaimed Heart Pine, Select reclaimed wide plank flooring
thumbnailantiquereclaimedheartpinecommongradelivingroom|Olde Wood Reclaimed Heart Pine, Common reclaimed wide plank flooring
heart-pine-original-face-listing|Olde Wood Reclaimed Heart Pine, Original Face reclaimed wide plank flooring
bs-thumb-prefinished-1|Olde Wood Prefinished Barn Siding
olde-wood-antique-reclaimed-hand-hewn-barn-beams|Olde Wood antique reclaimed hand hewn solid barn beams
olde-wood-antique-reclaimed-log-cabin-sleeper-skins|Olde Wood antique reclaimed log cabin sleeper skins
olde-wood-hand-hewn-reclaimed-fireplace-mantels|Olde Wood hand hewn reclaimed fireplace mantels
european-antique-reclaimed-oak-listing|Olde Wood European Antique Oak plank floor sample
euro-antique-resawn-oak-thumb|Olde Wood European Antique Resawn Oak plank floor sample
euro-antique-white-oak-thumb|Olde Wood European Antique White Oak plank floor sample
thumbnaileuropeanmountainoakallafamigliakitchen2-1|Olde Wood European Mountain Oak plank floor sample
european-white-oak-watermarked|Olde Wood European White Oak plank floor sample
euro-antique-oak-hitskip-thumb|Olde Wood European Antique Oak Hit Skip plank floor sample
euro-antique-white-oak-hitskip-thumb|Olde Wood European Antique White Oak Hit Skip plank floor sample
euro-antique-resawn-white-oak-thumb|Olde Wood European Antique Resawn White Oak plank floor sample
caramel-listing-2|Olde Wood Inspiration Caramel Plank floor sample
charred-listing|Olde Wood Inspiration Charred Plank floor sample
natural-listing|Olde Wood Inspiration Natural Plank floor sample
thumbnailsandalwoodlivingroom2|Olde Wood Inspiration Sandalwood Plank floor sample
thumbnailsmokeplankv2|Olde Wood Inspiration Smoke Plank floor sample
thumbnailtuscankitchen-1|Olde Wood Inspiration Tuscan Plank floor sample
whitewashed-listing-image|Olde Wood Inspiration Whitewashed Plank floor sample
inspiration-collection-urban-driftwood-listing|Olde Wood Inspiration Urban Driftwood Plank floor sample
magnolia-thumb-autumn|Olde Wood Magnolia Autumn plank floor sample
magnolia-thumb-bay-2-1|Olde Wood Magnolia Bay plank floor sample
magnolia-thumb-sandycreek|Olde Wood Magnolia Sandy Creek plank floor sample
magnolia-thumb-tudor|Olde Wood Magnolia Tudor plank floor sample
magnolia-thumb-honey|Olde Wood Magnolia Honey plank floor sample
sugar-plank-listing-2-|Olde Wood Magnolia Sugar plank floor sample
big-leaf-listing-1|Olde Wood Magnolia Big Leaf plank floor sample
magnolia-collection-english-plank-sample-image-website-listing-image|Olde Wood Magnolia English plank floor sample
java-plank-listing-1|Olde Wood Magnolia Java plank floor sample
prairie-plank-listing|Olde Wood Magnolia Prairie plank floor sample
camo-listing|Olde Wood Magnolia Camo Plank floor sample
metro-thumb-cobblestone|Olde Wood Metro Cobblestone Plank floor sample
urban-plank-owl1-3-watermarked|Olde Wood Metro Urban Plank floor sample
metro-thumb-penthouse|Olde Wood Metro Penthouse Plank floor sample
metro-thumb-espresso|Olde Wood Metro Espresso Plank floor sample
metro-thumb-terrace|Olde Wood Metro Terrace Plank floor sample
metro-thumb-cosmopolitan-2-1|Olde Wood Metro Cosmopolitan Plank floor sample
thumbnailstudiobedroom-1|Olde Wood Metro Studio Plank floor sample
metro-thumb-slate|Olde Wood Metro Slate Plank floor sample
metro-thumb-iron-2|Olde Wood Metro Iron Plank floor sample
reed-plank498x400|Olde Wood Metro River Stone Plank floor sample
standard-rift-and-quartered-listing|Olde Wood Standard Rift and Quartered White Oak plank floor sample
select-rift-and-quartered-listing|Olde Wood Select Rift and Quartered White Oak plank floor sample
select-white-oak-listing|Olde Wood Select & Prime White Oak Select plank floor sample
prime-white-oak-listing-1|Olde Wood Select & Prime White Oak Prime plank floor sample
thumbnailwhiteoaksuperprimehotel|Olde Wood Select & Prime White Oak Super Prime plank floor sample
thumbnailselecthickory17rivergrille|Olde Wood Select & Prime Hickory Select plank floor sample
venture-thumb-alpine-1|Olde Wood Venture Alpine plank floor sample
venture-thumb-dune|Olde Wood Venture Dune plank floor sample
venture-thumb-cosmos|Olde Wood Venture Cosmos plank floor sample
venturetwilightlistingwatermark|Olde Wood Venture Twilight plank floor sample
venture-thumb-savanna|Olde Wood Venture Savanna plank floor sample
venture-thumb-lodge|Olde Wood Venture Lodge plank floor sample
`);
export function oldeWoodPhotoAlt(src, fallback, reclaimedSample = false) {
  const file = decodeURIComponent(originalManufacturerImage(src).split('/').pop() || '').replace(/\.[^.]+$/, '');
  const alt = sampleAlts[file];
  return alt ? reclaimedSample ? alt.replace('reclaimed wide plank flooring', 'reclaimed wood flooring sample') : alt : fallback;
}
